import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-spinners',
  templateUrl: './ui-spinners.component.html',
  styleUrls: ['./ui-spinners.component.scss']
})
export class UiSpinnersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
